module.exports = __webpack_public_path__ + "static/codePenProjects-bcc542e5a78644b5a008f761180d814a.jpg";